import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    padding: 0 32px 32px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${mq.lt.md} {
        padding: 0 16px 16px;
    }
`;

export const Text = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    max-width: 560px;
`;
